/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  Divider,
  FormControl,
  Grid,
  Modal,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import React, { useContext, useState } from "react";
import ModalHeader from "../ModalHeader";
import {
  CaptureFingerPrint,
  GetMFS100InfoLoad,
} from "../../utils/MantraCapture";
import { AEPS_TYPE, RDDeviceStatus, TWOFASTATUS } from "../../utils/constants";
import AnimDeviceReady from "../../assets/animate-icons/device_ready.json";
import AnimDeviceScanning from "../../assets/animate-icons/fingerprint_scan.json";
import AnimDeviceSuccess from "../../assets/animate-icons/fingerprint_success.json";
import AnimDeviceFail from "../../assets/animate-icons/fingerprint_fail.json";
import AnimDeviceConnect from "../../assets/animate-icons/device_connect.json";
import AnimateIcon from "../../component/AnimateIcon";
import RdDeviceSearch from "../../component/RdDeviceSearch";
import MyButton from "../../component/MyButton";
import { apiErrorToast, okSuccessToast } from "../../utils/ToastUtil";
import { useEffect } from "react";
import { postJsonData } from "../../network/ApiController";
import ApiEndpoints from "../../network/ApiEndPoints";
import AuthContext from "../../store/AuthContext";
import Mount from "../../component/Mount";
import AePSOutletRegistration from "./AePSOutletRegistration";
import AePS2OutletRegistration from "./AePS2OutletRegistration";
import LoaderFull from "../../commons/LoaderFull";
import useCommonContext from "../../store/CommonContext";
import MyRadioButton from "../../component/Buttons/MyRadioButton";
import MachineDetectButton from "../../component/aeps/MachineDetectButton";
import Aeps1OutletStatusIpay from "../../component/Aeps1OutletStatusIpay";

export function getColor(status) {
  if (status === "NOTREADY") {
    return "red";
  } else if (status === "READY") {
    return "green";
  } else {
    return "red";
  }
}

const AEPS2FAModal = ({
  isAepsOne,
  isAepsTwo,
  twoFAStatus,
  setTwoFAStatus,
}) => {
  const [open, setOpen] = useState(true); // Changed to false
  const [request, setRequest] = useState(false);
  const [scanAnim, setScanAnim] = useState(RDDeviceStatus.READY);
  const context = useContext(AuthContext);
  const userLat = context.location.lat && context.location.lat;
  const userLong = context.location.long && context.location.long;
  const [aadhaar, setAadhaar] = useState("");

  const {
    aepsType,
    setAepsType,
    rdDevice,
    rdDeviceList,
    machineRequest,
    setRdDevice,
    setRdDeviceList,
    setMachineRequest,
    setAepsTypeInLocalAndHook,
  } = useCommonContext();
  const [scanData, setScanData] = useState();
  const [aepsOutlet, setAepsOutlet] = useState(false);
  const [showOutletStatusModal, setShowOutletStatusModal] = useState(false);

  const authCtx = useContext(AuthContext);
  const user = authCtx.user;

  const handleOpen = () => {
    console.log("Button clicked, checking user status:", {
      instId: user?.instId,
      outlet_status: user?.outlet_status,
      isAepsOne,
      isAepsTwo,
    });

    // First, check if we should open 2FA modal or go directly to registration
    if (isAepsOne && !isAepsTwo) {
      setAepsTypeInLocalAndHook(AEPS_TYPE.AEPS1);

      // Check scenarios immediately
      if (user) {
        // Scenario 1: instId is null and outlet_status is 0
        if (!user.instId && user.outlet_status === 0) {
          console.log(
            "Scenario 1: Opening AEPS1 outlet registration directly from button click",
          );
          setAepsOutlet(AEPS_TYPE.AEPS1);
          return; // Don't open 2FA modal
        }

        // Scenario 2: instId is not null and outlet_status is 0
        else if (user.instId && user.outlet_status === 0) {
          console.log(
            "Scenario 2: Opening AEPS1 outlet status modal directly from button click",
          );
          setShowOutletStatusModal(true); // Open outlet status modal
          return; // Don't open 2FA modal
        }

        // Scenario 3: instId is not null and outlet_status is 1
        else if (user.instId && user.outlet_status === 1) {
          console.log("Scenario 3: Opening 2FA modal for login");
          setOpen(true); // Open 2FA modal
        } else {
          // Default case
          console.log("Default case: Opening 2FA modal");
          setOpen(true);
        }
      }
    } else if (!isAepsOne && isAepsTwo) {
      setAepsTypeInLocalAndHook(AEPS_TYPE.AEPS2);

      if (user && !user.fingId) {
        console.log("AEPS2: Opening outlet registration");
        setAepsOutlet(AEPS_TYPE.AEPS2);
      } else {
        setOpen(true);
      }
    } else if (isAepsOne && isAepsTwo) {
      // Both types available, show selection modal
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setAepsType("");
    setAepsTypeInLocalAndHook("");
    localStorage.removeItem("aepsType");
  };

  function getRdDeviceInfo() {
    setMachineRequest(true);
    setTimeout(() => {
      GetMFS100InfoLoad(
        setMachineRequest,
        (dataArray) => {
          setScanData();
          for (let i = 0; i < dataArray.length; i++) {
            const data = dataArray[i];
            if (data && data.status === RDDeviceStatus.READY) {
              setScanAnim(data ? data.status : RDDeviceStatus.SCAN_FAILED);
              setRdDevice(data);
            } else if (data && data.status === RDDeviceStatus.NOT_READY) {
              setScanAnim(data ? data.status : RDDeviceStatus.SCAN_FAILED);
              setRdDevice(data);
            }
          }
          if (dataArray) setRdDeviceList(dataArray);
        },
        (err) => {
          setScanAnim(RDDeviceStatus.NOT_READY);
          setRdDevice();
          setRdDeviceList();
          setMachineRequest(false);
          setScanData();
        },
      );
    }, 500);
  }

  function resolveScanImage(status) {
    switch (status) {
      case RDDeviceStatus.NOT_READY:
        return <AnimateIcon src={AnimDeviceConnect} />;
      case RDDeviceStatus.READY:
        return <AnimateIcon src={AnimDeviceReady} />;
      case RDDeviceStatus.SCANNING:
        return <AnimateIcon src={AnimDeviceScanning} />;
      case RDDeviceStatus.SCAN_SUCCESS:
        return <AnimateIcon src={AnimDeviceSuccess} />;
      case RDDeviceStatus.SCAN_FAILED:
        return <AnimateIcon src={AnimDeviceFail} />;
      default:
        return <AnimateIcon src={AnimDeviceConnect} />;
    }
  }

  // Modified to ONLY handle Scenario 3 (outlet status check)
  const getAepsOutletStatus = (type) => {
    if (user) {
      postJsonData(
        ApiEndpoints.AEPS_OUTLET_STATUS,
        {
          pipe: type,
        },
        setRequest,
        (res) => {
          if (aepsType === AEPS_TYPE.AEPS1) {
            const data = res?.data;
            const message = data.message;

            console.log("Outlet status API response:", {
              message,
              instId: user.instId,
              outlet_status: user.outlet_status,
            });

            // This should only be called for Scenario 3
            if (message === TWOFASTATUS.LOGINREQUIRED) {
              setTwoFAStatus(TWOFASTATUS.LOGINREQUIRED);
            } else if (message === TWOFASTATUS.LOGGEDIN) {
              setTwoFAStatus(TWOFASTATUS.LOGGEDIN);
            }
          } else if (aepsType === AEPS_TYPE.AEPS2) {
            setTwoFAStatus(TWOFASTATUS.LOGGEDIN);
          }
        },
        (err) => {
          apiErrorToast(err);
        },
      );
    }
  };

  const outletAuthApiCall = () => {
    console.log("scanData?.errInfo", scanData?.errInfo);
    if (scanData) {
      let data = {};
      let apiEnd = ApiEndpoints.AEPS_OUTLET_LOGIN;
      if (aepsType === AEPS_TYPE.AEPS1)
        data = {
          AadharNumber: aadhaar && aadhaar,
          ci: scanData.cI,
          dc: scanData.dC,
          dpId: scanData.dpId,
          errInfo: scanData?.errInfo,
          fCount: scanData?.fCount,
          mc: scanData?.mC,
          mi: scanData?.mI,
          nmPoints: scanData?.nmPoints,
          pidData: scanData?.pidData,
          pidDataType: scanData?.pidDataType,
          qScore: scanData?.qScore || 50,
          rdsId: scanData?.rdsId,
          rdsVer: scanData?.rdsVer,
          sessionKey: scanData?.sessionKey,
          srno: scanData?.srno,
          hmac: scanData?.hMac,
          sysId: scanData?.sysId,
          latitude: userLat,
          longitude: userLong,
          pf: "WEB",
          type: "DAILY_LOGIN",
        };
      else if (aepsType === AEPS_TYPE.AEPS2) {
        apiEnd = ApiEndpoints.AEPS2_OUTLET_LOGIN;
        data = {
          adhaarNumber: aadhaar && aadhaar,
          captureResponse: scanData,
          deviceId: scanData.srno,
          latitude: userLat,
          longitude: userLong,
        };
      }
      postJsonData(
        apiEnd,
        data,
        setRequest,
        (res) => {
          okSuccessToast("Success");
          if (getAepsOutletStatus) getAepsOutletStatus(aepsType);
          handleClose();
        },
        (err) => {
          const errorData = JSON.stringify(err.response.data);
          apiErrorToast(errorData);
        },
      );
    } else {
      apiErrorToast("Scan first");
    }
  };

  useEffect(() => {
    if (scanData) outletAuthApiCall();
  }, [scanData]);

  useEffect(() => {
    if (isAepsOne && !isAepsTwo) {
      setAepsTypeInLocalAndHook(AEPS_TYPE.AEPS1);
    }
    if (!isAepsOne && isAepsTwo) {
      setAepsTypeInLocalAndHook(AEPS_TYPE.AEPS2);
    }
    return () => {};
  }, []);

  // This useEffect handles when aepsType changes (like when radio button is selected)
  useEffect(() => {
    console.log("aepsType changed to:", aepsType, "User:", {
      instId: user?.instId,
      outlet_status: user?.outlet_status,
    });

    if (aepsType === AEPS_TYPE.AEPS1 && user) {
      // Scenario 1: instId is null and outlet_status is 0
      if (!user.instId && user.outlet_status === 0) {
        console.log(
          "Scenario 1 (aepsType change): Opening AEPS1 outlet registration",
        );
        setAepsOutlet(AEPS_TYPE.AEPS1);
        setOpen(false);
      }
      // Scenario 2: instId is not null and outlet_status is 0
      else if (user.instId && user.outlet_status === 0) {
        console.log(
          "Scenario 2 (aepsType change): Opening AEPS1 outlet status modal",
        );
        setShowOutletStatusModal(true);
        setOpen(false);
      }
      // Scenario 3: instId is not null and outlet_status is 1
      else if (user.instId && user.outlet_status === 1) {
        console.log(
          "Scenario 3 (aepsType change): Checking outlet status via API",
        );
        getAepsOutletStatus(AEPS_TYPE.AEPS1);
      } else if (user.instId) {
        // Other cases where instId exists
        console.log("Other case with instId, checking outlet status");
        getAepsOutletStatus(AEPS_TYPE.AEPS1);
      }
    }

    if (aepsType === AEPS_TYPE.AEPS2 && user) {
      if (!user.fingId) {
        console.log("AEPS2: Opening outlet registration");
        setAepsOutlet(AEPS_TYPE.AEPS2);
        setOpen(false);
      } else {
        getAepsOutletStatus(AEPS_TYPE.AEPS2);
      }
    }
  }, [aepsType, user]);

  useEffect(() => {
    if (
      twoFAStatus &&
      aepsType === AEPS_TYPE.AEPS1 &&
      user.instId &&
      user.outlet_status === 1 &&
      (rdDeviceList === 0 || !rdDevice)
    ) {
      setTimeout(() => {
        getRdDeviceInfo();
      }, 200);
    } else if (
      twoFAStatus &&
      aepsType === AEPS_TYPE.AEPS2 &&
      user.fingId &&
      (rdDeviceList === 0 || !rdDevice)
    ) {
      setTimeout(() => {
        getRdDeviceInfo();
      }, 200);
    }
    return () => {};
  }, [twoFAStatus]);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "45%",
    bgcolor: "background.paper",
    boxShadow: 24,
    fontFamily: "Poppins",
    height: aepsType === AEPS_TYPE.AEPS1 ? "90vh" : "max-content",
    overflowY: "scroll",
    p: 2,
    pb: 3,
  };

  const handleOutletStatusClose = (statusData) => {
    setShowOutletStatusModal(false);
    console.log("Outlet status modal closed with data:", statusData);
  };

  const handleOutletRegistrationClose = () => {
    console.log("Outlet registration completed");
    setAepsOutlet(false);
  };
  console.log("AEPS2FAModal Rendered with states:", aepsOutlet);
  return (
    <Box
      sx={{
        display: "grid",
        justifyContent: "center",
        position: "relative",
      }}
    >
      <LoaderFull
        circle
        loading={machineRequest || request}
        text="Please wait . . . ."
      />
      <Button
        sx={{ textTransform: "none", maxHeight: "40px", px: 2, mt: 3 }}
        onClick={handleOpen}
        className="otp-hover-purple"
      >
        2 Factor Authentication
      </Button>

      {/* 2FA Modal - Only shows for Scenario 3 or when both AEPS types available */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="sm_modal">
          <ModalHeader
            title={
              isAepsOne && isAepsTwo
                ? "Select AePS Type"
                : "2 Factor Authentication"
            }
            subtitle="Enjoy seamless aadhaar services with Imps Guru"
            handleClose={handleClose}
          />
          <Box
            sx={{
              objectFit: "contain",
              width: "100%",
            }}
          >
            <Mount visible={isAepsOne && isAepsTwo}>
              <FormControl
                sx={{
                  width: "100%",
                }}
              >
                <RadioGroup
                  className="my-radio_flex"
                  name="row-radio-buttons-group"
                  aria-labelledby="aepstype-row-radio-buttons-group-label"
                  value={aepsType}
                  defaultValue={aepsType}
                  onChange={(e) => {
                    setAepsTypeInLocalAndHook(e.target.value);
                  }}
                >
                  <MyRadioButton
                    label="AePS1"
                    name="AePS1"
                    defaultChecked
                    value={AEPS_TYPE.AEPS1}
                    checked={aepsType === AEPS_TYPE.AEPS1}
                  />
                  <MyRadioButton
                    label="AePS2"
                    name="AePS2"
                    value={AEPS_TYPE.AEPS2}
                    checked={aepsType === AEPS_TYPE.AEPS2}
                  />
                </RadioGroup>
              </FormControl>
            </Mount>

            {/* aeps 2FA login view forms and options - Only for Scenario 3 */}
            <Mount
              visible={
                aepsType === AEPS_TYPE.AEPS1 &&
                twoFAStatus === TWOFASTATUS.LOGINREQUIRED &&
                user.instId &&
                user.outlet_status === 1
              }
            >
              <Divider
                sx={{
                  borderTop: "2px solid #d3d3d3",
                }}
              />
              <Box
                component="form"
                id="outlet_login"
                validate
                autoComplete="off"
                className="text-center"
                sx={{
                  "& .MuiTextField-root": { m: 2 },
                  objectFit: "contain",
                  display: "grid",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Grid container className="position-relative">
                  <Grid item md={12} xs={12}>
                    <FormControl sx={{ width: "100%" }}>
                      <TextField
                        autoComplete="off"
                        label="Aadhaar Number"
                        id="aadhaarNo"
                        size="small"
                        type="number"
                        required
                        value={aadhaar}
                        onChange={(e) => setAadhaar(e.target.value)}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} lg={12}>
                    <Box sx={{ display: "flex", pl: 1, pt: 1 }}>
                      <div
                        style={{
                          width: "50%",
                          minWidth: "30%",
                          height: "auto",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          position: "relative",
                        }}
                      >
                        {rdDevice && (
                          <div
                            style={{
                              background: getColor(
                                rdDevice ? rdDevice.status : "",
                              ),
                              width: "10px",
                              height: "10px",
                              borderRadius: "50%",
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                            }}
                          ></div>
                        )}
                        <span style={{ marginBottom: "12px" }}>
                          {resolveScanImage(scanAnim)}
                        </span>
                        <span
                          style={{
                            position: "absolute",
                            bottom: "8px",
                            display: "flex",
                            justifyContent: "between",
                            alignItems: "center",
                          }}
                        >
                          <MyButton
                            hidden={
                              !rdDevice ||
                              rdDevice.status === RDDeviceStatus.NOT_READY
                            }
                            text="start scan"
                            mr={3}
                            onClick={() => {
                              setScanAnim(RDDeviceStatus.SCANNING);
                              CaptureFingerPrint(
                                rdDevice && rdDevice.rdport,
                                (msg, data) => {
                                  setScanAnim(RDDeviceStatus.SCAN_SUCCESS);
                                  setScanData(data);
                                },
                                (err) => {
                                  apiErrorToast("Error", JSON.stringify(err));
                                  setScanAnim(RDDeviceStatus.SCAN_FAILED);
                                },
                              );
                            }}
                          />
                          <MachineDetectButton
                            onClick={() => {
                              if (getRdDeviceInfo) getRdDeviceInfo();
                            }}
                          />
                        </span>
                      </div>
                      <Grid container>
                        <Grid item md={12} xs={12}>
                          {
                            <RdDeviceSearch
                              list={rdDeviceList}
                              cb={(item) => {
                                if (item) setRdDevice(item);
                              }}
                              defaultValue={
                                rdDeviceList?.length > 0 &&
                                rdDeviceList[0]?.info
                              }
                            />
                          }

                          {!machineRequest && rdDeviceList === undefined && (
                            <Typography
                              sx={{
                                fontSize: "11px",
                                color: "red",
                                textAlign: "left",
                              }}
                            >
                              You do not have any RD Service installed in your
                              system
                            </Typography>
                          )}
                        </Grid>
                        <Grid item md={12} xs={12}>
                          <FormControl sx={{ width: "100%" }}>
                            <TextField
                              autoComplete="off"
                              label=""
                              id="d_status"
                              size="small"
                              placeholder="Device Status"
                              value={
                                rdDevice
                                  ? rdDevice.status
                                  : RDDeviceStatus.NOT_READY
                              }
                              disabled
                            />
                          </FormControl>
                        </Grid>
                        <Grid item md={12} xs={12}>
                          <FormControl sx={{ width: "100%" }}>
                            <TextField
                              autoComplete="off"
                              label=""
                              id="scan_quality"
                              size="small"
                              placeholder="Scan Quality"
                              defaultValue={""}
                              value={scanData && scanData.score}
                              disabled
                            />
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Box>
                    <Typography sx={{ mt: 2 }}>
                      <span style={{ fontWeight: "bold", color: "#DC5F5F" }}>
                        Note:
                      </span>{" "}
                      connect scanner for scanning the impression(when scanner
                      is connected dot in the corner will be green.)
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </Mount>
          </Box>
        </Box>
      </Modal>

      {/* AEPS1 Outlet Registration Modal - Always rendered but controlled by aepsOutlet state */}
      {aepsType === AEPS_TYPE.AEPS1 && (
        <AePSOutletRegistration
          open={aepsOutlet}
          setOpen={setAepsOutlet}
          onClose={handleOutletRegistrationClose}
        />
      )}

      {/* AEPS1 Outlet Status Modal - Scenario 2 */}
      {showOutletStatusModal && (
        <Aeps1OutletStatusIpay
          open={showOutletStatusModal}
          onClose={handleOutletStatusClose}
          refreshCallback={() => {
            console.log("Outlet status refreshed");
          }}
        />
      )}

      {/* AEPS2 Outlet Registration Modal */}
      {aepsType === AEPS_TYPE.AEPS2 && (
        <AePS2OutletRegistration open={aepsOutlet} setOpen={setAepsOutlet} />
      )}
    </Box>
  );
};
export default AEPS2FAModal;
